import React, { useState, useRef, useEffect } from "react";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import { useFetch } from "services/hooks/useFetch";
import { customAPI } from "services/utils/CustomAPI";
import { Info, Delete, AddCircle, Close, Check } from "@mui/icons-material";
import { tableRowSx, tableCellFontSize } from "services/constants"; // scrollTop,
import { CustomAutoComplete } from "components/CustomComponents";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  specialCharacterRestrict,
  atleastOneCharacterWithSpace,
} from "services/constants/patterns";
import {
  formHeader,
  formBackGroundColor,
  formKeyText,
} from "services/constants/Styles";
import { themes, optionalAvathar } from "services/constants";
import { BackArrow } from "components/CustomComponents";
import { rowEndStyle } from "services/constants/Styles";
import { CustomButton } from "components/CustomComponents";
export const CreateUserGroup = ({ setScreenNavigation }) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  //Add Company
  const [errorMessage, setErrorMessage] = useState("");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [addNewCompany, setAddNewCompany] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyId, setCompanyId] = useState(0);
  const [roleName, setRoleName] = useState("");
  const [roleNameId, setRoleNameId] = useState(0);
  const [companyListDetails, setCompanyListDetails] = useState([]);
  const [firstTimeTrigger, setFristTimeTrigger] = useState(true);

  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [userCompanyName, setUserCompanyName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userCode, setUserCode] = useState("");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [userImage, setUserImage] = useState("");
  const [addUser, setAddUser] = useState(false);
  const [userGroupName, setUserGroupName] = useState("");
  const tableContainerRef = useRef(null);
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  const [userDetails, setUserDetails] = useState([]);
  const [empData, setEmpData] = useState("");
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const { result: companyList, loading: activeCompanyLoading } = useFetch(
    `${domain}get-active-company/`
  );
  const { result: employeeList, loading: employeeListLoading } = useFetch(
    `${domain}un-grouped/users/`
  );

  const { result: productRoles } = useFetch(
    `${domain}product-control/roles/summary/`
  );

  useEffect(() => {
    const updateApiData = () => {
      setCompanyListDetails(companyList);
      setEmployeeDetails(employeeList);
    };

    if (firstTimeTrigger && !activeCompanyLoading && !employeeListLoading) {
      updateApiData();
      setFristTimeTrigger(false);
    }
  }, [
    activeCompanyLoading,
    companyList,
    employeeList,
    employeeListLoading,
    firstTimeTrigger,
  ]);

  // useEffect(() => {
  //   scrollTop(tableContainerRef);
  // }, [page]);

  const handleCompanyName = (event, data) => {
    if (data) {
      setCompanyId(data?.id);
      setCompanyName(data?.companyname);
    }
  };

  const validateProductName = () => {
    if (!userGroupName.trim()) {
      setErrorMessage("User group name is required");
      return false;
    } else if (userGroupName.length < 3) {
      setErrorMessage("Minimum 3 characters required");
      return false;
    } else if (!atleastOneCharacterWithSpace.test(userGroupName)) {
      setErrorMessage("At least one character is required");
      return false;
    } else {
      setErrorMessage("");
      return true;
    }
  };

  const handleProductRole = (event, data) => {
    if (data) {
      setRoleName(data?.label);
      setRoleNameId(data?.role_id);
    }
  };

  const createUserGroupDetails = async () => {
    const res = await customGetAPI(
      `${domain}unique/user-group/?name=${userGroupName.trim()}`
    );
    if (res.ok) {
      if (res?.responseDetails?.exists) {
        setErrorMessage("User group name already exists");
      } else {
        setErrorMessage("");
        if (validateProductName()) {
          if (companyDetails.length > 0) {
            const activeModuleIds = userDetails.map((item) => item.id);
            const response = await customAPI(
              `${domain}create-assign/user-group/`,
              "POST",
              {
                name: userGroupName.trim(),
                assignments: companyDetails,
                users: activeModuleIds,
              }
            );
            if (response.ok) {
              showToast(
                "success",
                "Users and group details are created successfully"
              );
              setScreenNavigation("");
              setEmpData("");
            }
          } else {
            setErrorMessage("At least one company is required.");
          }
        }
      }
    }
  };

  const addCompanyDetails = () => {
    if (companyName !== "" && roleName !== "") {
      let newCompany = {
        company_id: companyId,
        company_name: companyName,
        role_id: roleNameId,
        role_name: roleName,
      };
      setCompanyDetails([...companyDetails, newCompany]);
      companySelectedDataRemove();
      removeAddedCompanyDetails([...companyDetails, newCompany]);
      setErrorMessage("");
    } else {
      if (companyName === "") {
        setErrorMessage("Company name is required");
      } else {
        setErrorMessage("Role name is required");
      }
    }
  };

  const companySelectedDataRemove = () => {
    setCompanyName("");
    setCompanyId(0);
    setRoleName("");
    setRoleNameId(0);
    setAddNewCompany(false);
  };

  const removeAddedCompanyDetails = (AddedCompanyDetails) => {
    let companyData = companyListDetails;
    AddedCompanyDetails.forEach((element) => {
      companyData = companyData.filter((data) => {
        return data.companyname !== element.company_name;
      });
    });
    setCompanyListDetails(companyData);
  };

  const deleteCompanyAndRole = (item) => {
    let updatedCompany = companyDetails.filter((data) => {
      return data?.company_name !== item?.company_name;
    });
    setCompanyDetails(updatedCompany);
    removeAddedCompanyDetails(updatedCompany);
  };

  const handleUserCompanyName = (event, data) => {
    if (data) {
      setUserCompanyName(data?.companyname);
      let filterdata = employeeDetails.filter((company_data) => {
        return company_data?.company_id === data?.id;
      });
      setCompanyUsers(filterdata);
      clearUserDetails();
      setEmpData("");
    }
  };

  const handleUserCode = (event, data) => {
    if (data) {
      setUserEmail(data?.email);
      setUserCode(data?.user_code);
      setUserName(data?.user_name);
      setUserId(data?.id);
      setUserImage(data?.image_url);
      setEmpData(data);
    }
  };

  const handleUserName = (event, data) => {
    if (data) {
      setUserEmail(data?.email);
      setUserCode(data?.user_code);
      setUserName(data?.user_name);
      setUserId(data?.id);
      setUserImage(data?.image_url);
      setEmpData(data);
      setShowAutoCompleteAvathar(false);
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  // const handleUserEmail = (event, data) => {
  //   if (data) {
  //     setUserEmail(data?.email);
  //     setUserCode(data?.user_code);
  //     setUserName(data?.user_name);
  //     setUserId(data?.id);
  //   }
  // };

  const clearUserDetails = () => {
    setUserEmail("");
    setUserCode("");
    setUserName("");
    setUserId("");
    setUserImage("");
  };

  const addNewUser = () => {
    if (userCompanyName !== "" && userName !== "") {
      let newuser = {
        company: userCompanyName,
        user_code: userCode,
        name: userName,
        email: userEmail,
        id: userId,
        image_url: userImage,
      };
      setUserDetails([...userDetails, newuser]);
      removeAddedUserDetails([...userDetails, newuser]);
      setUserCompanyName("");
      setAddUser(false);
      clearUserDetails();
      setCompanyUsers([]);
      setErrorMessage("");
    } else {
      if (userCompanyName === "") {
        setErrorMessage("User company name is required");
      } else {
        setErrorMessage("User name is required");
      }
    }
  };

  const removeAddedUserDetails = (addedUser) => {
    let userData = employeeList;
    addedUser.forEach((element) => {
      userData = userData.filter((data) => {
        return data.user_code !== element.user_code;
      });
    });
    setEmployeeDetails(userData);
  };

  const deleteUser = (item) => {
    let users = userDetails.filter((data) => {
      return data?.user_code !== item?.user_code;
    });
    setUserDetails(users);
    removeAddedUserDetails(users);
  };

  const checkNameAlreadyExists = async () => {
    const res = await customGetAPI(
      `${domain}unique/user-group/?name=${userGroupName.trim()}`
    );
    if (res.ok) {
      if (res?.responseDetails?.exists) {
        setErrorMessage("User group name already exists");
        return false;
      } else {
        setErrorMessage("");
        return true;
      }
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 1 }}>
        <BackArrow
          actionFunction={() => {
            setScreenNavigation("");
          }}
        />
        &nbsp;
        <Mui.Typography
          sx={{
            fontSize: 22,
            paddingLeft: 1,
            fontWeight: "bold",
            paddingTop: 1,
          }}
        >
          Create User Group
        </Mui.Typography>
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          paddingTop: "5%",
          paddingLeft: "18%",
          paddingRight: "18%",
          paddingBottom: "5%",
        }}
      >
        <Mui.Grid
          container
          xs={12}
          sx={{
            border: `2px solid ${themes.sidebarDivider}`,
            borderRadius: "10px 10px 10px 10px",
          }}
        >
          <Mui.Grid
            xs={12}
            sx={{
              backgroundColor: formBackGroundColor,
              padding: {
                xs: 0.5,
                sm: 0.5,
                md: 0.5,
                lg: 0.5,
                xl: 1,
              },
              textAlign: "center",
              borderBottom: `2px solid ${themes.sidebarDivider}`,
            }}
          >
            <Mui.Typography sx={formHeader}>Create User Group</Mui.Typography>
          </Mui.Grid>
          <Mui.Grid container sx={{ padding: 2 }}>
            <Mui.Grid xs={1}></Mui.Grid>
            <Mui.Grid xs={4.5}>
              <Mui.Typography sx={formKeyText}>
                User Group Name &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter a name to identify this group of users who will share similar access and settings."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={4.4}>
              <Mui.TextField
                value={userGroupName}
                onChange={(event) => {
                  if (
                    specialCharacterRestrict.test(event.target.value) &&
                    event.target.value.length <= 100
                  ) {
                    setUserGroupName(event.target.value);
                  }
                }}
                sx={{
                  width: {
                    xs: 100,
                    sm: 150,
                    md: 250,
                    lg: 350,
                  },
                }}
                size="small"
                placeholder="Enter user group name"
                onBlur={() => {
                  checkNameAlreadyExists();
                }}
                error={
                  [
                    "User group name already exists",
                    "User group name is required",
                    "Minimum 3 characters required",
                    "At least one character is required",
                  ].includes(errorMessage)
                    ? true
                    : false
                }
              />
              {[
                "User group name already exists",
                "User group name is required",
                "Minimum 3 characters required",
                "At least one character is required",
              ].includes(errorMessage) && (
                <Mui.Typography
                  variant="body2"
                  color="error"
                  sx={{ fontSize: 13, paddingLeft: 1 }}
                >
                  {errorMessage}
                </Mui.Typography>
              )}
            </Mui.Grid>
          </Mui.Grid>
          {/* company details */}
          <Mui.Grid container>
            <Mui.Typography
              sx={{ fontWeight: "bold", forntSize: 20, paddingLeft: 2 }}
            >
              Company
            </Mui.Typography>
            &nbsp;
            <Mui.Tooltip
              arrow
              slotProps={tooltipStyleProps}
              title="Select one or more companies to associate with this user group for managing access and visibility."
            >
              <Info />
            </Mui.Tooltip>
            <Mui.TableContainer
              ref={tableContainerRef}
              sx={{ m: 1, width: "100%", maxHeight: 780 }}
            >
              <Mui.Table className="border">
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Company
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Role
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Action
                    </Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {
                    // companyDetails.length === 0 ? (
                    //   <Mui.TableRow>
                    //     <Mui.TableCell colSpan={12} align="center">
                    //       <Mui.Alert severity="info">No data available</Mui.Alert>
                    //     </Mui.TableCell>
                    //   </Mui.TableRow>
                    // ) : (
                    companyDetails
                      // ?.slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage
                      // )
                      ?.map((item, index) => (
                        <Mui.TableRow
                          maxWidth="xl"
                          align="left"
                          sx={{
                            cursor: "pointer",
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: "3px 15px",
                            },
                          }}
                        >
                          <Mui.TableCell>{item?.company_name}</Mui.TableCell>
                          <Mui.TableCell>{item?.role_name}</Mui.TableCell>
                          <Mui.TableCell>
                            <Mui.IconButton
                              onClick={() => {
                                deleteCompanyAndRole(item);
                              }}
                            >
                              <Delete />
                            </Mui.IconButton>
                          </Mui.TableCell>
                        </Mui.TableRow>
                      ))
                    // )
                  }
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {/* Add Company */}
          <Mui.Grid container sx={{ ...rowEndStyle, paddingLeft: 1 }}>
            {addNewCompany ? (
              <Mui.Grid container>
                <Mui.Grid xs={5} sx={{ padding: 1 }}>
                  <CustomAutoComplete
                    dataList={companyListDetails?.map((obj) => ({
                      ...obj,
                      label: obj.companyname,
                    }))}
                    selectedValue={companyName}
                    updateDataFunction={handleCompanyName}
                    placeHolder="Select company"
                  />
                  {errorMessage === "Company name is required" && (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1 }}
                    >
                      {errorMessage}
                    </Mui.Typography>
                  )}
                </Mui.Grid>
                <Mui.Grid xs={5} sx={{ padding: 1 }}>
                  <CustomAutoComplete
                    dataList={productRoles?.map((obj) => ({
                      ...obj,
                      label: obj?.role_name,
                    }))}
                    selectedValue={roleName}
                    updateDataFunction={handleProductRole}
                    placeHolder="Select Role"
                  />
                  {errorMessage === "Role name is required" && (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1 }}
                    >
                      {errorMessage}
                    </Mui.Typography>
                  )}
                </Mui.Grid>
                <Mui.Grid xs={2} sx={{ paddingTop: 1.5 }}>
                  <Mui.IconButton
                    sx={{
                      backgroundColor: themes.greenColor,
                      p: 0.5,
                      "&:hover": {
                        backgroundColor: themes.greenColor,
                      },
                    }}
                    onClick={() => {
                      addCompanyDetails();
                    }}
                  >
                    <Check sx={{ color: themes.whiteColor, fontSize: 18 }} />
                  </Mui.IconButton>{" "}
                  &nbsp;
                  <Mui.IconButton
                    sx={{
                      backgroundColor: themes.lightRedColor,
                      p: 0.5,
                      "&:hover": {
                        backgroundColor: themes.lightRedColor,
                      },
                    }}
                    onClick={() => {
                      companySelectedDataRemove();
                      setErrorMessage("");
                      setAddNewCompany(false);
                    }}
                  >
                    <Close sx={{ color: themes.whiteColor, fontSize: 18 }} />
                  </Mui.IconButton>
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
            <Mui.Grid container>
              {errorMessage === "At least one company is required." && (
                <Mui.Typography
                  variant="body2"
                  color="error"
                  sx={{ fontSize: 13, paddingLeft: 1 }}
                >
                  {errorMessage}
                </Mui.Typography>
              )}
            </Mui.Grid>
            {addNewCompany ? null : (
              <Mui.IconButton
                onClick={() => {
                  setAddNewCompany(true);
                }}
              >
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Add Company"
                >
                  <AddCircle />
                </Mui.Tooltip>
              </Mui.IconButton>
            )}
          </Mui.Grid>
          {/* end company details */}
          {/* user List */}
          <Mui.Grid container>
            <Mui.Typography
              sx={{ fontWeight: "bold", forntSize: 20, paddingLeft: 2 }}
            >
              User List
            </Mui.Typography>
            &nbsp;
            <Mui.Tooltip
              arrow
              slotProps={tooltipStyleProps}
              title="Add individual users to this group to grant them the permissions and scope defined under the group."
            >
              <Info />
            </Mui.Tooltip>
            <Mui.TableContainer
              ref={tableContainerRef}
              sx={{ m: 1, width: "100%", maxHeight: 780 }}
            >
              <Mui.Table className="border">
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Company
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Name
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      User code
                    </Mui.TableCell>

                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Email
                    </Mui.TableCell>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        fontSize: tableCellFontSize,
                      }}
                    >
                      Action
                    </Mui.TableCell>
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {
                    // userDetails.length === 0 ? (
                    //   <Mui.TableRow>
                    //     <Mui.TableCell colSpan={12} align="center">
                    //       <Mui.Alert severity="info">No data available</Mui.Alert>
                    //     </Mui.TableCell>
                    //   </Mui.TableRow>
                    // ) : (
                    userDetails
                      // ?.slice(
                      //   page * rowsPerPage,
                      //   page * rowsPerPage + rowsPerPage
                      // )
                      ?.map((item, index) => (
                        <Mui.TableRow
                          maxWidth="xl"
                          align="left"
                          sx={{
                            cursor: "pointer",
                            "& .MuiTableCell-root": {
                              height: "10px",
                              padding: "3px 15px",
                            },
                          }}
                        >
                          <Mui.TableCell>{item?.company}</Mui.TableCell>
                          <Mui.TableCell>
                            <Mui.Stack direction="Row">
                              <Mui.Avatar
                                sx={{ width: 23, height: 23 }}
                                alt="Remy Sharp"
                                src={item?.image_url ?? optionalAvathar}
                              />
                              &nbsp;
                              {item?.name}
                            </Mui.Stack>
                          </Mui.TableCell>
                          <Mui.TableCell>{item?.user_code}</Mui.TableCell>
                          <Mui.TableCell>{item?.email}</Mui.TableCell>
                          <Mui.TableCell>
                            <Mui.IconButton
                              onClick={() => {
                                deleteUser(item);
                              }}
                            >
                              <Delete />
                            </Mui.IconButton>
                          </Mui.TableCell>
                        </Mui.TableRow>
                      ))
                    // )
                  }
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {errorMessage === "At least one user is required." && (
            <Mui.Typography
              variant="body2"
              color="error"
              sx={{ fontSize: 13, paddingLeft: 1 }}
            >
              {errorMessage}
            </Mui.Typography>
          )}
          {/* end user list*/}
          {/* Add user details */}
          <Mui.Grid container sx={{ ...rowEndStyle, paddingLeft: 1 }}>
            {addUser ? (
              <Mui.Grid container>
                <Mui.Grid xs={2.7} sx={{ padding: 1 }}>
                  <CustomAutoComplete
                    dataList={companyList?.map((obj) => ({
                      ...obj,
                      label: obj.companyname,
                    }))}
                    selectedValue={userCompanyName}
                    updateDataFunction={handleUserCompanyName}
                    placeHolder="Select Company"
                  />
                  {errorMessage === "User company name is required" && (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1 }}
                    >
                      {errorMessage}
                    </Mui.Typography>
                  )}
                </Mui.Grid>
                <Mui.Grid xs={2.7} sx={{ padding: 1 }}>
                  <CustomAutoCompleteWithLogo
                    dataList={companyUsers?.map((obj) => ({
                      ...obj,
                      label: obj?.user_name,
                      image: obj?.image_url,
                    }))}
                    selectedValue={empData}
                    updateDataFunction={handleUserName}
                    placeHolder="Select user name"
                    showAvathar={showAutoCompleteAvathar}
                    setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
                  />
                  {errorMessage === "User name is required" && (
                    <Mui.Typography
                      variant="body2"
                      color="error"
                      sx={{ fontSize: 13, paddingLeft: 1 }}
                    >
                      {errorMessage}
                    </Mui.Typography>
                  )}
                </Mui.Grid>
                <Mui.Grid xs={2.7} sx={{ padding: 1 }}>
                  <CustomAutoComplete
                    dataList={companyUsers?.map((obj) => ({
                      ...obj,
                      label: obj?.user_code.toString(),
                    }))}
                    selectedValue={userCode}
                    updateDataFunction={handleUserCode}
                    placeHolder="Select user code"
                  />
                </Mui.Grid>

                <Mui.Grid xs={2.7} sx={{ padding: 1 }}>
                  <Mui.Box sx={{ paddingTop: 1 }}>{userEmail}</Mui.Box>
                  {/* <CustomAutoComplete
                    dataList={companyUsers?.map((obj) => ({
                      ...obj,
                      label: obj?.email,
                    }))}
                    selectedValue={userEmail}
                    updateDataFunction={handleUserEmail}
                    placeHolder="Select email"
                  /> */}
                </Mui.Grid>
                <Mui.Grid xs={1.2} sx={{ paddingTop: 1.5 }}>
                  <Mui.IconButton
                    sx={{
                      backgroundColor: themes.greenColor,
                      p: 0.5,
                      "&:hover": {
                        backgroundColor: themes.greenColor,
                      },
                    }}
                    onClick={() => {
                      addNewUser();
                    }}
                  >
                    <Check sx={{ color: themes.whiteColor, fontSize: 18 }} />
                  </Mui.IconButton>{" "}
                  &nbsp;
                  <Mui.IconButton
                    sx={{
                      backgroundColor: themes.lightRedColor,
                      p: 0.5,
                      "&:hover": {
                        backgroundColor: themes.lightRedColor,
                      },
                    }}
                    onClick={() => {
                      setAddUser(false);
                      setUserCompanyName("");
                      clearUserDetails();
                    }}
                  >
                    <Close sx={{ color: themes.whiteColor, fontSize: 18 }} />
                  </Mui.IconButton>
                </Mui.Grid>
              </Mui.Grid>
            ) : null}
            {addUser ? null : (
              <Mui.IconButton
                onClick={() => {
                  setAddUser(true);
                  setEmpData("");
                }}
              >
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Add User"
                >
                  <AddCircle />
                </Mui.Tooltip>
              </Mui.IconButton>
            )}
          </Mui.Grid>
          {/* End add user details */}
        </Mui.Grid>
      </Mui.Grid>
      <Mui.Grid container sx={{ ...rowEndStyle, paddingRight: 4 }}>
        <CustomButton
          actionFuntion={() => {
            setScreenNavigation("");
          }}
          actionName="Cancel"
          typeName="button"
        />{" "}
        &nbsp;
        <CustomButton
          actionFuntion={() => {
            createUserGroupDetails();
          }}
          actionName="Create"
          typeName="button"
        />
      </Mui.Grid>
    </React.Fragment>
  );
};
